import { render, staticRenderFns } from "./vehicleInsuranceAdd.vue?vue&type=template&id=00a1c626&scoped=true"
import script from "./vehicleInsuranceAdd.vue?vue&type=script&lang=js"
export * from "./vehicleInsuranceAdd.vue?vue&type=script&lang=js"
import style0 from "./vehicleInsuranceAdd.vue?vue&type=style&index=0&id=00a1c626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1c626",
  null
  
)

export default component.exports